import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { ConstantService } from 'src/app/service/constant.service';

@Component({
  selector: 'app-load-iframe',
  templateUrl: './load-iframe.component.html',
  styleUrls: ['./load-iframe.component.styl']
})
export class LoadIframeComponent implements OnInit {
  gameUrl: any;
  IsVerified = true;
  DisplayMessage: any = '';
  // public _secureHtml: any = '';
  @ViewChild('gameFrame') gameFrame: ElementRef;
  IFrameSizeInterval: any;
  IframeSize = 0;
  constructor(
    private domSanitizer: DomSanitizer,
    public constant: ConstantService,
    public translateService: TranslateService
  ) {
    this.constant.lobbyGameDropDown = true;
    this.gameUrl = sessionStorage.getItem('GameUrl') ? JSON.parse(sessionStorage.getItem('GameUrl')) : '';
  }

  ngOnInit() {
    clearInterval(this.IFrameSizeInterval);
    const url = new URL(window.location.href);
    const Token = sessionStorage.getItem('AuthToken');
    // let gameUrlToken1 = this.gameUrl.split('?')[1];
    // let gameUrlToken = this.gameUrl.get('Token');
    // gameUrlToken = gameUrlToken ? gameUrlToken?.split('=')[1] : '';
    // sessionStorage.setItem('AuthToken', gameUrlToken);
    // if ((Token && Token !== '') || gameUrlToken) {
    if ((Token && Token !== '')) {
      this.constant.IsVerified = true;
      this.getcommonList();
      this.addIframeResizeEventListener();
    } else {
      this.constant.IsVerified = false;
      this.DisplayMessage = this.translateService.instant('Invalid Token. Please Login Again');
    }
    if (!this.gameUrl) {
      this.IsVerified = false;
      this.constant.tmpGameList = [];
      // this.router.navigate(['/']);
    } else {
      this.IsVerified = true;
      this.constant._secureHtml = this.domSanitizer.bypassSecurityTrustResourceUrl(this.gameUrl);
      this.constant.onViewChange.subscribe(x => {
        if (x.gameUrl) {
          this.constant._secureHtml = null;
          setTimeout(() => {
            this.constant._secureHtml = this.domSanitizer.bypassSecurityTrustResourceUrl(x.gameUrl);
          }, 0);
        }
      });
    }
  }

  get transform() {

    if (this.constant._secureHtml) {

      let url = new URL(this.constant._secureHtml.changingThisBreaksApplicationSecurity);
      let Lng = url.searchParams.get('ln');
      if (Lng === this.constant.translate.store.currentLang) {
        return this.constant._secureHtml;
      } else {
        return this.updateQueryStringParameter(url.href, 'ln', this.constant.translate.store.currentLang);
      }
    } else {
      return '';
    }
  }

  getGameUrl(event) {
    this.IsVerified = true;
    sessionStorage.setItem('GameUrl', JSON.stringify(event));

    this.constant._secureHtml = '';
    setTimeout(() => {
      this.constant._secureHtml = this.domSanitizer.bypassSecurityTrustResourceUrl(event);
    }, 0);
  }

  getcommonList() {
    this.constant.newsList = sessionStorage.getItem('NewsList') ? JSON.parse(sessionStorage.getItem('NewsList')) : [];
    this.constant.gameId = sessionStorage.getItem('GameId') ? JSON.parse(sessionStorage.getItem('GameId')) : 0;
    this.constant.gameName = sessionStorage.getItem('GameName');
    this.constant.userName = sessionStorage.getItem('UserName');
    this.constant.chipsSetting = sessionStorage.getItem('ChipSetting') ? JSON.parse(sessionStorage.getItem('ChipSetting')) : '';
  }

  addIframeResizeEventListener() {
    window.addEventListener('message', (event) => {
      clearInterval(this.IFrameSizeInterval);
      this.IFrameSizeInterval = setInterval(() => {
        this.resizeIframe(event);
      }, 1000);
    });
  }

  resizeIframe(event) {
    // if (this.gameFrame) {
    const height = event.data.height;
    if (height) {
      if (this.IframeSize != height) {
        // this.gameFrame.nativeElement.style.height = height + 'px';
        document.getElementById("gameIFrame").style.height = height + 'px';
        this.IframeSize = height;
      }
    }
    // } else {
    //   // setTimeout(() => {
    //   //   this.resizeIframe(event);
    //   // }, 250);
    // }
  }
  iframeLoded() {
    setTimeout(() => {
      this.constant.isIfreameLodded = false;
      this.constant.sendData();
    }, 1000);
    this.constant.isLObbyLoad = false;
  }


  updateQueryStringParameter(uri, key, value) {

    var re = new RegExp("([?&])" + key + "=.*?(&|#|$)", "i");
    if (value === undefined) {
      return this.domSanitizer.bypassSecurityTrustResourceUrl(uri);
    } else {
      if (uri.match(re)) {
        this.gameUrl = uri.replace(re, '$1' + key + "=" + value + '$2');
        // console.log(this.gameUrl);
        this.constant._secureHtml = this.domSanitizer.bypassSecurityTrustResourceUrl(this.gameUrl);
        return this.domSanitizer.bypassSecurityTrustResourceUrl(uri);
      } else {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(uri);
      }
    }
  }
}